module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "personal-center-form__section prepayment_cont"
  }, [_c('h1', {
    staticClass: "loan_detail_h1"
  }, [_vm._v("Prepayment")]), _vm._v(" "), _c('div', {
    staticClass: "loan_detail_first"
  }, [_c('ul', {
    staticClass: "text-center"
  }, [_c('li', [_c('em', [_vm._v("Total amount of current payment")]), _vm._v(" "), _c('strong', [_c('i', [_vm._v("$ " + _vm._s(_vm._f("addThousandSign")(_vm.detail.repayAmount, 2)))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detail.repayDate))])]), _vm._v(" "), _c('li', [_c('el-button', {
    staticClass: "repay_btn",
    attrs: {
      "disabled": _vm.isDisabled,
      "loading": _vm.isRepay
    },
    on: {
      "click": _vm.toRepay
    }
  }, [_vm._v(_vm._s(_vm.toRepayText))])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "info-card"
  }, [_c('div', {
    staticClass: "info-card-item"
  }, [_c('span', {
    staticClass: "info-card-item-ch ml10"
  }, [_vm._v("Unpaid principal")]), _vm._v(" "), _c('span', {
    staticClass: "info-card-item-num"
  }, [_vm._v("$ " + _vm._s(_vm._f("addThousandSign")(_vm.detail.repayPrincipal, 2)))]), _vm._v(" "), _c('i', {
    staticClass: "vertical-line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-card-item"
  }, [_c('span', {
    staticClass: "info-card-item-ch"
  }, [_vm._v("Loan fees")]), _vm._v(" "), _c('span', {
    staticClass: "info-card-item-num"
  }, [_vm._v("$ " + _vm._s(_vm._f("addThousandSign")(_vm.detail.repayInterest, 2)))])])]), _vm._v(" "), (_vm.isrepayTip) ? _c('div', {
    staticClass: "repayTip",
    domProps: {
      "innerHTML": _vm._s(_vm.repayTip)
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8f7f936"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/Prepayment.vue
// module id = 2020
// module chunks = 5